module.exports = __webpack_public_path__ + "static/media/14UNEP15.d1a719db.jpg";